import { PsValues, PsResult } from './types';
import { ToolsTranslations } from '@/lib/translations/types';

export function calculatePs(values: PsValues, t?: ToolsTranslations['ps']): PsResult {
  const { pricePerShare, revenuePerShare } = values;

  if (pricePerShare <= 0) {
    return {
      psRatio: null,
      isValid: false,
      message: t?.invalid.pricePerShare ?? 'Pris per aktie måste vara större än 0'
    };
  }

  if (revenuePerShare <= 0) {
    return {
      psRatio: null,
      isValid: false,
      message: t?.invalid.revenuePerShare ?? 'Omsättning per aktie måste vara större än 0'
    };
  }

  const psRatio = Math.round((pricePerShare / revenuePerShare) * 100) / 100;

  if (!isFinite(psRatio)) {
    return {
      psRatio: null,
      isValid: false,
      message: t?.invalid.generic ?? 'Ogiltiga värden'
    };
  }

  let interpretation = '';
  if (psRatio < 1) {
    interpretation = t?.additionalInfo?.undervalued ?? 'Undervärderat (< 1x)';
  } else if (psRatio <= 3) {
    interpretation = t?.additionalInfo?.fairValue ?? 'Rättvärderat (1-3x)';
  } else {
    interpretation = t?.additionalInfo?.overvalued ?? 'Övervärderat (> 3x)';
  }

  return {
    psRatio,
    isValid: true,
    interpretation
  };
}


